import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import Spinner from "../../Components/Spinner";
import DataGridTable from "../../Components/DataGridTable";
import { BASE_URL_API } from "../../Constants";
import { useAuth } from "../../hooks/AuthProvider";
import { useNavigate } from 'react-router-dom';

import { LanguageContext } from "../../context/LanguageContext";
import "./UserHealthDetails.css";
import {
  getHealthTranslations,
  HealthPageHeader,
  PermissionDenied,
  isRtlLanguage,
} from "./userHealthShared";

export const UserHealth = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { permissions, org } = useAuth();

  const { lang } = useContext(LanguageContext);
  const t = getHealthTranslations(lang);

  const canView = permissions["view_users_health"];

  const isRtl = isRtlLanguage(lang);

  const pagingoptions = [10, 20, 50, 100];


  const columns = [
    {
      field: "userName",
      headerName: t.columns.user,
      width: 250,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "weight",
      headerName: t.columns.weight,
      width: 150,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "height",
      headerName: t.columns.height,
      width: 150,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "bmi",
      headerName: t.columns.bmi,
      width: 120,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "age",
      headerName: t.columns.age,
      width: 120,
      align: "center",
      headerAlign: "center"

    },
    {
      field: "gmtCreate",
      headerName: t.columns.createdAt,
      width: 200,
      align: "center",
      headerAlign: "center"


    },
  ];

  const fetchData = useCallback(async () => {
    if (!canView) return;

    setLoading(true);

    try {
      const res = await axios.get(`${BASE_URL_API}/user-health/by-org/${org.id}`);

      if (Array.isArray(res.data?.data)) {
        const formatted = res.data.data.map((item) => ({
          ...item,
          userName: item.user?.name || "",
        }));

        setRows(formatted);
      } else {
        setRows([]);
      }
    } catch (err) {
      console.error("UserHealth fetch error:", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, [canView, org?.id]);
  const handleRowClick = (params) => {
    navigate('/users-health/details/' + params.row.id);
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (!canView) {
    return (
      <PermissionDenied title={t.states.permissionDenied} message={t.states.cannotViewHealth} />
    );
  }

  return (
    <div className="configuration devices-page health-page" dir={isRtl ? "rtl" : "ltr"} style={{ height: "100%" }}>
      <div className="device-main health-page-shell">
        <HealthPageHeader
          title={t.pages.records}
          subtitle={t.descriptions.records}
        />

        {loading ? (
          <Spinner />
        ) : rows.length > 0 ? (
          <div className="table-wrapper" style={{ flex: 1 }}>
            <DataGridTable
              columns={columns}
              rows={rows}
              idcolumn={"id"}
              pagingoptions={pagingoptions}
              sortField="created_at"
              sortType="desc"
              showToolbar={true}
              tableKey="user_health"
              handleRowClick={handleRowClick}

            />
          </div>
        ) : (
          <div className="health-empty-state">{t.states.noData}</div>
        )}
      </div>
    </div>
  );
};
